import orderBy from "lodash/orderBy";
import moment from "moment";
import PropTypes from "prop-types";

const CSVExport = (props) => {
  const formatSize = (bytes) => {
    let formattedSize;
    if (props.selectedSizeFormat === "GB") {
      formattedSize = (bytes / 1000000000).toFixed(2);
    } else if (props.selectedSizeFormat === "TB") {
      formattedSize = (bytes / 1000000000000).toFixed(2);
    } else if (props.selectedSizeFormat === "MB") {
      formattedSize = (bytes / 1000000).toFixed(2);
    }
    return formattedSize;
  };

  const exportDataToCSV = () => {
    const filename = "export_" + moment().format("YYYYMMDD_HHmmss") + ".csv";
    const headerStr = props.dataKeys.map((key, i) => {
      if (key.match(/size/gi)) {
        key += " (" + props.selectedSizeFormat + ")";
      }

      if (props.dataKeys.length === i + 1) {
        return key + "\n";
      } else {
        return key;
      }
    });

    const totalStr = props.dataKeys.map((key, i) => {
      let valStr;
      switch (key) {
        case "Size":
          valStr = formatSize(props.totalSize).toString();
          break;
        case "Hits/Downloads":
          valStr = props.totalHits.toString();
          break;
        case "Visitors":
          valStr = props.totalVisitors.toString();
          break;
        case "Views":
          valStr = props.totalViews.toString();
          break;
        case "Average Daily Size":
          valStr = formatSize(props.avgDailySize).toString();
          break;
        case "Average Daily Hits":
          valStr = props.avgDailyHits.toFixed(0).toString();
          break;
        case "Description":
          valStr = "Total";
          break;
        default:
          valStr = "";
      }
      if (props.dataKeys.length === i + 1) {
        return valStr + "\n";
      } else {
        return valStr;
      }
    });

    const dataArray = orderBy(
      props.data,
      props.sortField,
      props.sortDirection
    ).map((dataItem) => {
      let rowStr = "";
      props.dataKeys.forEach((key, i) => {
        if (isNaN(dataItem[key])) {
          rowStr += dataItem[key];
        } else {
          if (key.match(/Size/g)) {
            rowStr += formatSize(dataItem[key]).toString();
          } else if (key.match(/Hits/g)) {
            rowStr += dataItem[key].toFixed(0).toString();
          } else {
            rowStr += dataItem[key].toString();
          }
        }

        if (props.dataKeys.length === i + 1) {
          rowStr += "\n";
        } else {
          rowStr += ",";
        }
      });
      return rowStr;
    });

    dataArray.unshift(headerStr);
    dataArray.push(totalStr);

    let dataArrayStr = "";
    dataArray.forEach((item) => {
      dataArrayStr += item;
    });

    if (dataArray.length > 1) {
      const blob = new Blob([dataArrayStr], { type: "text/csv" });

      if (navigator.msSaveBlob) {
        // IE 10+
        navigator.msSaveBlob(blob, filename);
      } else {
        const link = document.createElement("a");
        if (link.download !== undefined) {
          // feature detection
          // Browsers that support HTML5 download attribute
          const url = URL.createObjectURL(blob);
          link.setAttribute("href", url);
          link.setAttribute("download", filename);
          link.style.visibility = "hidden";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      }
    }
  };
  if (props.data.length === 0) return <div />;

  return (
    <a href="#" onClick={exportDataToCSV.bind(this)}>
      Export Table to CSV
    </a>
  );
};

export default CSVExport;

CSVExport.propTypes = {
  selectedSizeFormat: PropTypes.string,
  dataKeys: PropTypes.array,
  data: PropTypes.array,
  totalSize: PropTypes.number,
  totalHits: PropTypes.number,
  totalVisitors: PropTypes.number,
  totalViews: PropTypes.number,
  avgDailySize: PropTypes.number,
  avgDailyHits: PropTypes.number,
  sortField: PropTypes.string,
  sortDirection: PropTypes.string,
};
